import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { Subtitle } from '../components/blocks/Subtitle';

export const isSubtitle = isElementType(Subtitle);
